<template lang="pug">
.form-design.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.design" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.design }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="design" title="Nombre Diseño Ingles")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteDesign")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlDesign from '@/graphql/design'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInput from '@/components/elements/Input'
import shProperty from '@/components/elements/Property'

export default {
  name: 'FormDesign',

  mixins: [mForm, mDB],

  components: { shDeleteButton, shInput, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        design: ''
      },
      resolver: 'design',
      key: 'design',
      gql: gqlDesign
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newDesign()
      } else {
        this.updateDesign()
      }
    },

    newDesign () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateDesign () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteDesign () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-design
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/design/Form.vue